import React from 'react';
import { Space, Typography } from 'antd';

const { Title } = Typography;

const TitleWithIcon = ({ icon, text }) => (
  <Title level={5}>
    <Space size="small">
      {icon}
      {text}
    </Space>
  </Title>
);

export default TitleWithIcon;
